import { createPortal } from 'react-dom';

import { Dialog, DialogContent } from '@/components/ui/dialog';

import useModalStore from '@/store/modal.store';

export const GlobalModal = () => {
  const { isOpen, view, closeModal } = useModalStore();

  if (!isOpen || !view) return null;

  return createPortal(
    <Dialog open={isOpen} onOpenChange={closeModal}>
      <DialogContent>{view()}</DialogContent>
    </Dialog>,
    document.body
  );
};
